import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { TargetPromoState, noPrizeContent } from '../../store/target-promotion.selectors';

@Component({
    selector: 'no-prize',
    templateUrl: './no-prize.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, DsCard],
})
export class NoPrizeComponent {
    @Input() isDisabled: boolean;

    noPrizeContent$ = this.store.select(noPrizeContent);
    dsComponents: DSComponents;

    constructor(
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
        private designSystemHelperService: DesignSystemHelperService,
    ) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }
}
